import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, MenuButton } from '../Button'
import {
  BannerImage,
  BannerLink,
  BannerProvider,
  BannerText,
  BannerTextBox,
  BannerTitle
} from './components'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

const Banner = ({ show }) => {
  const { t, i18n } = useTranslation()

  const navigate = useNavigate()

  return (
    <BannerProvider show={show}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <BannerImage src='/luma-flower.svg' show={show} />
        <BannerTextBox show={show}>
          <BannerTitle>{t('banner-title')}</BannerTitle>
          <BannerText>
            {t('banner-text1')}
            <BannerLink style={{ fontWeight: '600', textUnderlineOffset: '2px' }}
              href='https://www.helsinki.fi/fi/tiedekasvatus/opettajille-ja-opetuksen-tueksi/opintokaynnit-ja-lainattavat-tarvikkeet'
              target='_blank'
              rel='noreferrer'
            >{t('banner-text2')}</BannerLink>
            {t('banner-text3')}
          </BannerText>
          <div className='calendar-instruction' style={{ backgroundColor: 'rgb(255 242 225)', color: '#1A202C', padding: '.75rem', marginTop: '0.5rem', borderLeft: '1px solid #FF991C', borderLeftWidth: '0.5rem' }}>
            <BannerText>
              {t('banner-instructions')}
            </BannerText>
          </div>
          <div style={{ marginLeft: -10, marginTop: 5, display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <MenuButton className='active' onClick={() => navigate('/')}>{t('calendar')}</MenuButton>
              <MenuButton className='active' onClick={() => navigate('/info')}>{t('info')}</MenuButton>
            </div>
            <div>
              <Button className='active' onClick={() => i18n.changeLanguage('fi-FI')}>FI</Button>
              <Button className='active' onClick={() => i18n.changeLanguage('sv-SV')}>SV</Button>
              <Button className='active' onClick={() => i18n.changeLanguage('en-US')}>EN</Button>
            </div>
          </div>
        </BannerTextBox>
      </div>
    </BannerProvider>
  )
}

export default Banner

Banner.propTypes = {
  show: PropTypes.bool.isRequired
}
